/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { useState } from 'react'
import Version from './Version'
import imgLogo from '../../assets/img/logo.png'
import imgES from '../../assets/img/es.png'
import imgEN from '../../assets/img/en.png'

/* ANTD */
import Icon from 'antd/es/icon'
import Modal from 'antd/es/modal'
import Popover from 'antd/lib/popover'

/* ANTD MOBILE */
import NavBar from 'antd-mobile/es/nav-bar'

import 'antd/dist/antd.css'
import 'antd-mobile/dist/antd-mobile.css'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'

const { confirm } = Modal

const TopBarNav = (props) => {
  const history = useHistory()
  const [visible, setVisible] = useState(false)
  const [claims] = useState({})
  const { t } = useTranslation();


  const handleLogoff = () => {
    setVisible(false)
    props.tokenExpired()
    history.push('/login')
  }

  const handleVisibleChange = (value) => {
    setVisible(value)
  }

  const changeLanguage =(lng) =>{
    i18n.changeLanguage(lng)
  }

  const onLogOff = () => {
    confirm({
      title: t('commonMessages.logout'),
      content: '',
      onOk() {
        handleLogoff()
      },
      onCancel() { }
    })
  }

  return (

    <div className="element-header">
      <div className="container element-no-padding">
        <NavBar
          leftContent={
            <div>
              <img src={imgLogo} alt='' style={{height:60,width:210}}/>
            </div>
          }
          rightContent={
            <table border="0">
              <tbody>
                <tr>
                  <td style={{ width: '35px', textAlign: 'center' }}>

                    <Popover
                      title=""
                      placement="bottomRight"
                      trigger="click"
                      visible={visible}
                      onVisibleChange={(v) => handleVisibleChange(v)}
                      content={
                        <div>

                          <div style={{ width: 300 }} className="element-col-align-center">
                            <b>{t('common.hello')} {claims.name}</b>
                          </div>
                          <br />
                          <div style={{ width: 300 }} className="element-col-align-center">
                            {claims.email}
                          </div>
                          <hr />
                          <div style={{ width: 300 }} className="element-col-align-center">
                            <img 
                              className={i18n.language === 'es' ? 'element-cursor-hand' : 'element-cursor-hand element-image-disabled'}
                              onClick={() => changeLanguage('es')}
                              src={imgES} 
                              alt='' />
                            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <img 
                              className={i18n.language === 'en' ? 'element-cursor-hand' : 'element-cursor-hand element-image-disabled'}
                              onClick={() => changeLanguage('en')}
                              src={imgEN} 
                              alt=''  />
                          </div>
                          <hr />
                          <div style={{ width: 300, height: '25px' }} className="element-col-align-center">
                            <Version />
                          </div>
                        </div>
                      } >
                      <div>
                        <Icon type="user" style={{ fontSize: '24px', cursor: 'pointer' }} />
                      </div>
                    </Popover>

                  </td>
                  <td style={{ width: '35px', textAlign: 'center' }}>
                    <Icon onClick={onLogOff} type="poweroff" style={{ fontSize: '24px' }} />
                  </td>
                </tr>
              </tbody>
            </table>
          }
        ></NavBar>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  isUserAuthenticated: state.LoginReducer.isAuthenticated,
  userToken: state.LoginReducer.token,
  userLanguage: state.LoginReducer.language,
})

const mapDispatchToProps = dispatch => {
  return {
    tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopBarNav)
